<template>
  <div
    class="absolute rounded-full flex items-center justify-center w-6 h-6 md:w-8 md:h-8 md:w-12 md:h-12 right-0 bottom-0"
    :class="`${bgColor}`"
  >
    <i :class="icon" class="text-white ds-text-xs md:ds-text-xl" />
  </div>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    bgColor: { type: String, required: true }
  }
};
</script>